import type { Integrations } from '@/integrations';
import type { IntegrationsStore } from '@teemill/modules/integration-framework';
import { defineStore } from 'pinia';
import type { RouteLocationRaw } from 'vue-router';

export interface State extends IntegrationsStore<Integrations> {
  ready: boolean;
  redirect?: RouteLocationRaw;
}

export const useIntegrationsStore = defineStore('integrations', {
  state: (): State => ({
    ready: false,
    integrations: {} as Integrations,
    installations: {},
    extensions: [],
    redirect: undefined,
  }),

  actions: {
    setIntegrations(integrations: Integrations) {
      this.integrations = integrations;
    },
    updateRedirect(redirect?: RouteLocationRaw) {
      this.redirect = redirect;
    },
  },
});
